// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-malawi/calculator-malawi-business-loan/calculator-malawi-business-loan.component.scss
// module id = 653
// module chunks = 0